/* global site: false, __: false, app: true, win: true, urlParams: false, pad: false */

$(document).ready(function(){
	app.head = $('header#main-header');
	app.scrollToTop = $('#scroll-to-top');

	$('body').css('padding-top', $('#main-header').height());

	if(sessionStorage.getItem('alert-hidden')){
		$('#alert-message').hide();
		$('body').css('padding-top', $('#main-header').height());
	}

	var toggleFaqs = function(scope){
		var that = $(scope);

		that.closest('.faq-item').siblings().find('.answer').slideUp();
		that.closest('.faq-item').siblings().find('h4').removeClass('open');
		that.toggleClass('open');
		that.nextAll('.answer').slideToggle().promise().done(function(){
			scrollTo(scope, 1000, 100);
		});
	};

	$('.faqs-block h4').click(function(){
		toggleFaqs(this);
	});

	$('.faqs-block h4').on('focus', function(){
		var that = this;

		$(that).on('keydown', function(e){
			if(e.which === 32 || e.which === 13){
				toggleFaqs(that);
			}
		});
	}).on('blur', function(){
		var that = this;

		$(that).off('keydown');
	});

	/**
	 * Add and removes the hasValue class from inputs for label position
	 */
	$('input, textarea').each(function(){
		var that = $(this);

		if(that.val()){
			that.addClass('hasValue');
			that.nextAll('.clear-input').click(function(e){
				that.val('');
				that.removeClass('hasValue');
			});
		}
	}).on('blur', function(){
		var that = $(this);

		if(that.val()){
			that.addClass('hasValue');
			that.nextAll('.clear-input').click(function(e){
				that.val('');
				that.removeClass('hasValue');
			});
		}else{
			that.removeClass('hasValue');
		}
	});

	/**
	 * Changes the language in a ~~super~~ much less jank way.
	 */
	$('#language-switcher').change(function(e){
		var that = $(this);

		window.location = $('link[hreflang="' + that.val() + '"]').attr('href');
	});

	$('.close-alert-button').click(function(e){
		var alertBar = $('#alert-message'),
			alertBarInner = $('.alert-message-inner');

		e.preventDefault();

		sessionStorage.setItem('alert-hidden', 'true');
		alertBarInner.slideUp();
		alertBar.animate({
			height: 0
		},
		{
			progress: function(){
				$('body').css('padding-top', $('#main-header').height());
			}
		}).promise().done(function(){
			alertBar.remove();
		});
	});

	/**
	 * Creates the image modal. Currently works on img tags with class modal-img.
	 * the data-target att on the img should be a link to the full size image. if no target is provided, the src is used
	 */
	$('img.modal-img, .et_pb_gallery_item img').click(function(e){
		var src = $(this).attr('data-target') || $(this).attr('src'),
			img = document.createElement('img');

		e.preventDefault();
		if(!e.originalEvent) return;

		app.makeModals('image-modal');
		img.src = src;
		img.onload = function(){
			app.modalContent.html(img);
			app.modal.css({
				'height': $(img).height(),
				'width': $(img).width(),
				'top': -$(img).height() / 2,
				'margin': '50vh auto 0'
			});
		};
	});

	/**
	 * Creates an ajax modal. Currently works on anchor tags with class modal-ajax and pulls out the data-target attr.
	 * that attr should be a class/id/attr on the target page. if no data-target is present, the #main content is used
	 */
	$('a.modal-ajax').click(function(e){
		var url = $(this).attr('href') + '?modal',
			target = $(this).attr('data-target') || 'article';

		e.preventDefault();
		app.makeModals('seamless-modal');
		$.get(url, function(data){
			if($(data).find(target).length){
				app.modalContent.html($(data).find(target));
			}else{
				app.modalContent.html($(data).find('article'));
			}

			app.modal.css({
				'height': $(target).height(),
				'margin': 'calc(35vh - ' + $(target).height() / 2 + 'px) auto 0'
			});

			app.observeIntersections(app.modal[0]);
		});
	});

	/**
	 * This makes the sidebar sticky, if it exists.
	 */
	if($('aside#main-sidebar').length && $(window).width() > 980){
		var sidebarWrapper = $('aside#main-sidebar'),
			stop = $('footer#main-footer'),
			wd, hi;

		app.sidebarInner = $('aside#main-sidebar > div');

		app.moveSidebar = function(){
			if(win.scrollTop() >= sidebarWrapper.offset().top - 20 && app.sidebarInner.height() < win.height() - app.head.height()){
				wd = app.sidebarInner.width();
				hi = app.sidebarInner.height();
				sidebarWrapper.css('height', sidebarWrapper.height());
				app.sidebarInner.css({
					'position': 'fixed',
					'top': 20,
					'width': wd,
					'height': hi
				});
			}else{
				app.sidebarInner.removeAttr('style');
				sidebarWrapper.removeAttr('style');
			}

			if(win.scrollTop() + app.sidebarInner.height() >= stop.offset().top - 41){
				app.sidebarInner.css({
					'top': stop.offset().top - win.scrollTop() - hi - 21
				});
			}

			return app.sidebarInner.offset().top;
		};
	}

	$('nav#main-navigation ul ul a').focus(function(){
		var that = $(this);

		that.closest('ul').prev('a').addClass('child-has-focus');
	}).blur(function(){
		var that = $(this);

		that.closest('ul').prev('a').removeClass('child-has-focus');
	});

	/**
	 * The actions for the button that shows/hides the menu on mobile.
	 * TODO Find a better way to apply the no-scroll class to the body. i dont like doing it based on a number. or at least a static number
	 */
	$('#burger, .close-sidebar').click(function(e){
		e.preventDefault();
		$('#burger, header#main-header nav').toggleClass('show');

		if(win.outerWidth() <= 600){
			$('body').toggleClass('no-scroll');
		}
	});

	/**
	 * Just a thing to make the window scroll
	 */
	app.scrollToTop.click(function(e){
		scrollTo('html');
	});

	/**
	 * Grabs all the hash links and runs the scrollTo function
	 */
	$('a[href*="#"]').click(function(e){
		if(location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname){
			e.preventDefault();
			scrollTo(this.hash);
			$(this.hash).attr('tabindex', '-1').focus().blur().removeAttr('tabindex');
		}
	});

	/**
	 * Shows and hides FAQ content on all pages that use the shortcode
	 */
	$('.faq-slide-content h4').click(function(e){
		var that = $(this),
			hasClass = that.nextAll('div').hasClass('open');

		$('.faq-slide-content div').removeClass('open');

		if(!hasClass){
			setTimeout(function(){
				that.nextAll('div').addClass('open');
			}, 301);
		}
	});

	/**
	 * format phone numbers on input blur
	 * @return {[type]} [description]
	 */
	$('input[type="tel"]').blur(function(){
		$(this).val(app.formatPhoneNumber($(this).val()));
	});

	/**
	 * Attach calendars to all inputs of type "date"
	 */
	$('input[type="date"]').each(function(){
		var that = $(this),
			date = app.calendar({
				element: app.createCal(),
				on_select: function(newDate){
					that.val(function(){
						return newDate.getFullYear() + '-' + pad(newDate.getMonth() + 1, 2) + '-' + pad(newDate.getDate(), 2);
					});
					that.addClass('hasValue');
					that.nextAll('.clear-input').click(function(e){
						that.val('');
						that.removeClass('hasValue');
						date.element.removeClass('show');
					});
					date.element.removeClass('show');
				},
				is_valid: function(date){
					return date.getTime() > new Date().getTime();
				}
			});

		that.parent().append(date.element).click(function(e){
			if(e.target === that[0]){
				$('.calendar').removeClass('show');
				that.siblings(date.element).addClass('show');
				win.on('click', date.close);
			}
		});
	});

	/**
	 * move the sidebar and parallaxes on page load in case the window isnt at the top
	 */
	if(typeof app.moveSidebar === 'function') app.moveSidebar();

	if(win.scrollTop() >= app.head.offset().top + app.head.outerHeight()){
		app.scrollToTop.addClass('show');
	}

	/**
	 * Adds scrollEvent function to various event listeners.
	 * This was done to make sure all scrolling events (ie touch, scroll, etc) are in passive mode.
	 */
	for(var ni = 0; ni < app.movementEvents.length; ++ni){
		document.addEventListener(app.movementEvents[ni], app.scrollEvent, {passive: true});
	}

	$('#mailchimp-signup').submit(function(e){
		var that = $(this),
			data = {
				action: 'submit_mailchimp',
				data: urlParams(that.serialize())
			};

		e.preventDefault();

		$.ajax({
			type: 'POST',
			url: app.ajaxUrl,
			data: data,
			success: function(data){
				data = JSON.parse(data);

				if(data.status > 0){
					that.html('<div class="row"><div class="col-xs-11 pr-0"><p class="success">' + data.message + '</p></div></div>');
				}else{
					that.append('<div class="row"><div class="col-xs-11 pr-0"><p class="error">' + data.message + '</p></div></div>');
				}
			}
		});
	});
});

/**
 * Hide the fullscreen loader. This happens at window.load so we can wait for all images to load too
 */
$(window).on('load', function(){
	app.observeIntersections();
	$('#fullscreen-loading').addClass('hide');
	$('header#main-header, main#main, footer#main-footer').removeClass('blur');
	setTimeout(function(){
		$('#fullscreen-loading').remove();
		$('body').removeClass('no-scroll');
		if(typeof app.afterLoad === 'function'){
			app.afterLoad();
		}

		scrollTo(location.hash);
		$(location.hash).attr('tabindex', '-1').focus().blur().removeAttr('tabindex');
	}, 301);

	setTimeout(function(){
		$('.parallax').each(function(){
			var that = $(this),
				height = that.height(),
				top = that.offset().top,
				img = document.createElement('img');

			img.src = that.css('background-image').replace(/url\(['|"]?(.*[^'|"])['|"]?\)/, '$1');
			that[0].top = top;
			that[0].bottom = top + height;
			that[0].center = (top + that[0].bottom) / 2;
			img.onload = function(){
				that[0].amount = (img.height / img.width) * 100;
				app.moveParallax(that);
			};
		});
	}, 100);
});
